






import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  flex?: boolean
}>(
  {
    props: ['flex'],
  },
  () => class {},
)
